import { FormikProps, FormikValues } from "formik";

/**
 * Translates a select's stored value into an optional filter id: the "Alle …" sentinel and an empty
 * selection both mean "no filter", and the sentinel must never reach an endpoint that expects an id.
 */
export function toOptionalId(id: string | null, allSentinel: string): string | undefined {
  return id === null || id === allSentinel ? undefined : id;
}

/**
 * An `onValueChange` handler for a select that offers an "Alle …" entry: clearing the select means
 * "no filter", which is that entry — so the control snaps back to it instead of sitting empty.
 */
export function snapBackToAllOption<T extends FormikValues>(
  formik: FormikProps<T>,
  field: Extract<keyof T, string>,
  allSentinel: string
): (id: string | null) => void {
  return (id) => {
    if (id === null) {
      void formik.setFieldValue(field, allSentinel);
    }
  };
}
